import React from 'react'
import './Preload.css'
import $ from 'jquery'
import Cookies from 'universal-cookie'
import { Box } from '@mui/material';
const cookies=new Cookies();

export default function Preload({dashboardMode}) {


  return (
    <div 
      style={{
        width:'100vw',
        height:'100vh',
        position:'fixed',
        zIndex:234223,
        top:0,
        left:0,
        right:0,
        bottom:0,
        backdropFilter:'blur(5px)',
        display:'flex',
        justifyContent: 'center',
        alignItems:'center',
        overflow:'hidden',
        backgroundColor:dashboardMode?'transparent':'#045980'
    }}
    >
      {/* <Box className="btn btn-primary text-light position-fixed" sx={{top:window.location.pathname=="/system/dashboard"?'-54px':'04px',left:'6px',position:'absolute',zIndex:9999999}} onClick={handleSession}>Get New Session SID</Box> */}

        <div className="spinner-box">
            <div className="leo-border-1">
                <div className="leo-core-1"></div>
            </div> 
            <div className="leo-border-2">
                <div className="leo-core-2"></div>
            </div> 
        </div>

    </div>
  )
}
